import { render, staticRenderFns } from "./P38.vue?vue&type=template&id=a5b83398&scoped=true"
import script from "./P38.ts?vue&type=script&lang=ts&external"
export * from "./P38.ts?vue&type=script&lang=ts&external"
import style0 from "./P38.vue?vue&type=style&index=0&id=a5b83398&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b83398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5b83398')) {
      api.createRecord('a5b83398', component.options)
    } else {
      api.reload('a5b83398', component.options)
    }
    module.hot.accept("./P38.vue?vue&type=template&id=a5b83398&scoped=true", function () {
      api.rerender('a5b83398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/pages/P38/P38.vue"
export default component.exports